export default "images/stanley1.jpg";